import { useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

import { useSubjectSelector } from '@procom-labs/common'

import { GorillaAppBar } from '@resume-portal/components'
import { AccessTypes } from '@resume-portal/models'
import { CommonRoutesPaths } from '@resume-portal/routes/routes.enum'
import { userOrganizationStore } from '@resume-portal/stores'

export const Layout = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { hasServicePlan, userOrgAccessType } = useSubjectSelector(
    userOrganizationStore,
    ['hasServicePlan', 'userOrgAccessType']
  )

  useEffect(() => {
    if (
      hasServicePlan === false &&
      location.pathname !== CommonRoutesPaths.PricingAndPlans &&
      location.pathname !== CommonRoutesPaths.CheckoutComplete &&
      userOrgAccessType === AccessTypes.Admin
    ) {
      navigate(CommonRoutesPaths.PricingAndPlans)
    }
  }, [hasServicePlan, navigate, location.pathname, userOrgAccessType])

  return (
    <>
      <GorillaAppBar />
      <Outlet />
    </>
  )
}
